// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__Lllbo","rotate":"Spinner_rotate__weYbW","path":"Spinner_path__+0FW1","dash":"Spinner_dash__vmNdV"};